export default {
  FWB: 'FWB',
  SWB: 'SWB',
  PRP: 'PRP',
  FFP: 'FFP',
  FP: 'FP',
  PRBCS: 'PRBCS'
}
